/**
 * @desc 列表
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(body: defs.mns.MessageMasterRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/messageMaster/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
